import { get } from 'libs/fetch';

/* get request */
export type Degree = {
  id: number;
  name: string;
}

export const index = async (
  callback: (responseData: Degree[]) => void,
  forbiddenCallback?: () => void,
) => {
  const res = await get('api/v1/admin/degrees');
  const body = await res.json();

  if (res.status === 200) {
    const responseData: Degree[] = body.degree;
    callback(responseData)
  } else if (res.status === 403) {
    forbiddenCallback?.();
  }
}
